import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAssetSamsungIconOl = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			rx: 13,
			fill: "#7882FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.6294 20.0392L30.5532 18.7439L30.1722 17.982C32.6865 20.2677 33.9818 22.7058 33.2199 24.6106C32.6103 26.363 30.477 27.3534 27.5818 27.5058C24.7627 27.6582 21.258 27.0487 17.677 25.6773C14.4749 24.5382 11.5435 22.7482 9.06748 20.4201C7.01034 18.363 6.09605 16.2296 6.78177 14.4773C7.46748 12.6487 9.82939 11.7344 12.9532 11.6582H13.0294C11.6335 12.7698 10.5342 14.2093 9.82939 15.8487C10.5151 17.7534 13.1818 20.0392 18.4389 22.2487C22.7056 24.0011 27.7341 24.9153 29.9437 23.4677H30.0961C30.4008 22.3249 30.6294 21.182 30.6294 20.0392Z",
			fill: "#4D5CC1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.5521 18.7441C30.7375 20.3081 30.5815 21.8937 30.095 23.3917C27.8855 24.9155 22.7807 24.0774 18.4378 22.2488C13.1807 19.9631 10.514 17.7536 9.9045 15.8488C10.5876 14.2177 11.6602 12.7789 13.0283 11.6583L13.1045 11.5821C14.6105 10.3914 16.4063 9.6229 18.3075 9.35548C20.2087 9.08805 22.1468 9.33135 23.9229 10.0604C25.699 10.7894 27.2491 11.978 28.4141 13.504C29.5791 15.0301 30.317 16.8386 30.5521 18.7441ZM19.8855 30.7822C17.0935 30.7846 14.4087 29.7077 12.3924 27.7766C10.3761 25.8455 9.18437 23.2097 9.06641 20.4202C14.0722 25.115 20.7196 27.6591 27.5807 27.506C26.5733 28.5481 25.3655 29.3755 24.0299 29.9386C22.6943 30.5016 21.2587 30.7886 19.8093 30.7822H19.8855Z",
			fill: "white"
		})
	]
});
export default SvgAssetSamsungIconOl;
